import Token from '@/di/di.token'

import useService from './useService'

export default function useActivityService() {
  const { service } = useService(Token.ACTIVITY_SERVICE)
  return { service }
}
